import PageviewChart from "../widgets/PageviewChart";
import {PAGEVIEWS_AGGREGATION_DAY} from "../../data/repository";
import {usePostPageviews} from "../../hook/useEditPost";

const PostPageviewsBarChartWidget = ({postId})=>{

    const pageviews = usePostPageviews(postId);

    return  <PageviewChart
        value={pageviews}
        aggregation={PAGEVIEWS_AGGREGATION_DAY}
        height={180}
    />
}

export default PostPageviewsBarChartWidget;